"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToMangopayTimestamp = transformDateToMangopayTimestamp;
function transformDateToMangopayTimestamp(date) {
    const dateToTransform = new Date(date);
    return Math.floor(dateToTransform.getTime() / 1000);
}
//# sourceMappingURL=transformDateToMangopayTimestamp.js.map